<template>
  <div class="row no-gutters">
    <div class="col-md-8 col-7 align-self-center">
      <p class="mb-0 body-2-1">{{ data.variant_name }}</p>
      <div class="w-100 mb-0 no-ws" :key="dom_key">
        <p class="mb-0 font-lato text-18 text-orange d-inline-block align-middle">{{ $formatCurrency(data.best_price.best_price.final_price) }}</p>
        <p v-if="data.best_price.best_price.promotion_price < 0" class="mb-0 font-lato text-14 ml-2 d-inline-block align-middle text-line-through text-semi-light">{{ $formatCurrency(data.best_price.price_sell) }}</p>
      </div>
    </div>
    <div class="col-md-4 col-5 align-self-center">
      <button v-if="avlb == 0 && qty == 0" class="g-btn g-btn-light d-table ml-auto px-4" :class="is_mobile_view ? 'g-btn-sm' : 'g-btn-md'" disabled>Out Of Stock</button>
      <div v-else class="no-ws text-right ticket-variant-item"> 
        <div class="d-inline-block align-middle text-center border-form radius-6 cursor-pointer action" @click="decItem()">
          <svg class="lh-1 minus" viewBox="0 0 16 3" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 2.28571H0V0H16V2.28571Z" fill="black" fill-opacity="0.54"/>
          </svg>
        </div>
        <div class="d-inline-block align-middle text-center qty">
          <p class="mb-0 font-lato text-dark lh-1">{{ qty }}</p>
        </div>
        <div class="d-inline-block align-middle text-center border-form radius-6 cursor-pointer action" @click="incItem()">
          <svg class="lh-1 plus" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 9.14286H9.14286V16H6.85714V9.14286H0V6.85714H6.85714V0H9.14286V6.85714H16V9.14286Z" fill="black" fill-opacity="0.54"/>
          </svg>
        </div>
        <div class="w-100 mt-2 text-right pr-4" v-if="showRemainingTicket()">
          <p class="mb-0 body-3-3-2 text-danger">{{avlb}} ticket left</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters,mapActions } from 'vuex';

  export default {
    props:['data','product_index_vuex','product'],
    data(){
      return{
        dom_key: 0
      }
    },
    computed:{
      ...mapGetters(['getTicketCart','getMerchant']),
      is_mobile_view(){
				return window.innerWidth > 768 ? false : true
			},
      qty(){
        if(this.product_index_vuex != -1){
          let ticket_cart = this.getTicketCart.ticket_details[this.product_index_vuex]
          let ticket_variant_cart = ticket_cart.variant.findIndex(x=>x.data.id == this.data.id)
          return ticket_variant_cart == -1 ? 0 : ticket_cart.variant[ticket_variant_cart].qty
        }else{
          return 0
        }
      },
      avlb(){
        return this.$getAvlb(this.data)
      },
      product_special(){
        return Object.keys(this.getTicketCart.product_special).length == 0 ? '' : this.getTicketCart.product_special.id
      }    
    },
    watch:{
      product_special(){
        this.dom_key++
      }
    },
    methods:{
      ...mapActions(['ticketAddItemCart','ticketDecItemCart','ticketResetItemCart']),
      showRemainingTicket(){
        return this.avlb > 0 && (this.getMerchant.product_availability_max_show == null || this.avlb <= this.getMerchant.product_availability_max_show)  ? true : false
      },
      incItem(){
        if(this.avlb > 0){
          let data = {
            ticket: this.$deepCopy(this.product),
            variant: this.data
          }
          delete data.ticket.variants
          this.ticketAddItemCart(data);
        }
			},
      decItem(){
        let data = {
          ticket: this.$deepCopy(this.product),
          variant: this.data
        }
        delete data.ticket.variants
        this.ticketDecItemCart(data);
			},
    }
  }
</script>
<style>
  .ticket-variant-item .action{
    height: 35px;
    width: 35px;
  }
  .ticket-variant-item svg.minus{
    margin-top: 16px;
    width: 16px;
    height: 3px;
  }
  .ticket-variant-item svg.plus{
    margin-top: 8px;
    width: 16px;
    height: 16px;
  }
  .ticket-variant-item .qty{
    height: 35px;
    width: 60px;
  }
  .ticket-variant-item .qty p{
    padding-top: 8px;
    font-size: 18px;
  }
  @media screen and (max-width: 768px){
    .ticket-variant-item .action{
      height: 30px;
      width: 30px;
    }
    .ticket-variant-item .qty{
      width: 50px;
      height: 30px;
    }
    .ticket-variant-item .qty p{
      padding-top: 5.5px;
      font-size: 16px;
    }
    .ticket-variant-item svg.minus{
      margin-top: 13.5px;
    }
    .ticket-variant-item svg.plus{
      margin-top: 5.5px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/ticket/Variant.vue